import React, { Component } from 'react';
import { Row, Col, Modal, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import 'react-block-ui/style.css';
import SignalRService from '../../controllers/SignalRService';
import {  Switch } from 'devextreme-react';
import { connect } from 'react-redux';
import { compose } from 'redux';
class Channels extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            channels: []
        };
        this.setChannels = this.setChannels.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    setChannels(channels) {

        let data = [];

        channels.forEach((channel) => {
            data.push({
                id: channel.name,
                value: !channel.disabled
            })
        });

        this.setState({
            channels: data
        });
    };

    showModal(e) {
        SignalRService.registerChannelsList(this.setChannels);
        SignalRService.getChannels({ userId: this.props.userId, extension: this.props.extension });
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    handleChange(e) {

        let chnIndex = this.state.channels.findIndex(x => `chnchk_${x.id.toLowerCase()}` === e.element.id),
            channels = this.state.channels;

        if (e.event) {
            e.event.preventDefault();

            channels[chnIndex].value = e.value;
            SignalRService.enableChannel({
                "extension": this.props.extension,
                "userId": this.props.userId,
                "channel": this.state.channels[chnIndex].id,
                "enable": e.value
            }, error => { });
        }

        this.setState({
            channels: channels
        });
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="sm">
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("chart-network")} /> {this.props.t("channels")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>

                        {
                            this.state.channels.map((v, i) => {
                                return (
                                    <Row>
                                        <Col > <span className="fs-5 text-gray-800 ">{this.props.t(v.id.toLowerCase())}</span></Col>
                                        <Col>
                                            <Switch key={`chnchk_${v.id.toLowerCase()}`}
                                                switchedOnText={this.props.t("yes")}
                                                switchedOffText={this.props.t("no")}
                                                id={`chnchk_${v.id.toLowerCase()}`}
                                                value={this.state.channels[i].value}
                                                enableThreeStateBehavior={false}
                                                iconSize="25"
                                                onValueChanged={this.handleChange}
                                                rtlEnabled={true}
                                            />
                                        </Col>
                                    </Row>
                                )
                            })
                        }
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        rtl: state.parameters.rtl
    };
};
export default compose(connect(mapStateToProps, {}), withTranslation())(Channels);